'use client';

import { type FC, useContext } from 'react';
import { Button, Flex, ButtonGroup, Text } from '@/_components';
import type { BulkTypeSelectorProps } from './BulkTypeSelector.types';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';

export const BulkTypeSelector: FC<BulkTypeSelectorProps> = ({
  isDisabled,
  entityTypeCounts,
  setSelectedTypes,
  selectedTypes = [],
}) => {
  const { firmEntityTypes } = useContext(FirmSettingsContext);

  if (!firmEntityTypes?.length || !setSelectedTypes) return null;

  return (
    <Flex isColumn={true} gap={4}>
      {!!selectedTypes?.length && (
        <Text type="tiny" color="primary">
          Selecting entity types will send Questionnaires to all matching
          entities.
        </Text>
      )}
      <ButtonGroup isSmallGroup={true}>
        {firmEntityTypes?.map((entityType, key) => {
          const isEntityTypeSelected: boolean =
            selectedTypes.includes(entityType);

          const onSelectType = () => {
            const newSelectedTypes: Array<string> = isEntityTypeSelected
              ? selectedTypes.filter((type) => type !== entityType)
              : [...selectedTypes, entityType];

            return setSelectedTypes(newSelectedTypes);
          };

          return !!entityTypeCounts[entityType] ? (
            <Button
              key={key}
              isActive={isEntityTypeSelected}
              value={entityType}
              count={entityTypeCounts[entityType] ?? 0}
              isDisabled={isDisabled}
              iconLeft={isEntityTypeSelected ? 'check-circle-filled' : 'plus'}
              intent="secondary"
              size="tiny"
              onClick={onSelectType}
            />
          ) : null;
        })}
      </ButtonGroup>
      {isDisabled && (
        <Text type="tiny" color="secondary">
          Please remove the current selection to enable bulk entity selection.
        </Text>
      )}
    </Flex>
  );
};
